import { useCallback, useMemo } from 'react'
import { v5 as uuidv5 } from 'uuid'
import { getCookie } from '@chilecompra/react-kit/storages'

/**
 * Custom hook to get the access token.
 */
export const useAccessToken = () => {
  return useMemo(() => {
    const accessToken = getCookie('access_token')

    // when the SSO service is down, the access token is a stringify null.
    if (!accessToken || accessToken === 'null') {
      return null
    }

    return accessToken
  }, [])
}

/**
 * Custom hook to get a secure URL.
 */
export const useSecureURL = () => {
  const accessToken = useAccessToken()

  return useCallback(
    path => {
      const isHashPath = path[0] === '#'

      if (!accessToken) {
        return path
      }

      if (isHashPath) {
        return `?t=${accessToken}${path}`
      }

      return `${path}?t=${accessToken}`
    },
    [accessToken]
  )
}

/**
 * Custom hook to get a csrf-token.
 */
export const useCsrfToken = key => useMemo(() => uuidv5(key, uuidv5.DNS), [])
